import Cookies from "universal-cookie";
import { getApiAsyn, baseUrl, getPythonApiAsyn, basePYUrl } from "../../PostAPI";
import { post, put } from "axios";
import { handleAPIError, APIError } from "../../common/errorHandler";
import { getDecoratedUrl } from "../../common/urlService";
import { API_URL } from "../../../constants/urlConstants";

const cookies = new Cookies();

export const fetchCustomer = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.CUSTOMER.GET,
    payload,
  });

  try {
    const result = await getPythonApiAsyn(url, cookies.get("authorization"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: cookies.get("authorization"),
    },
  };

  if (isEdit) {
    return put(basePYUrl + url, data, config);
  } else {
    return post(basePYUrl + url, data, config);
  }
};

export const editCustomerRecord = async (payload) => {
  try {
    const url = API_URL.CUSTOMER.EDIT.replace(":id", payload?.id);
    const result = await dataUploadApi(url, payload, true);

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchCustomerById = async (id) => {
  const url = API_URL.CUSTOMER.GET_BY_ID.replace(":id", id);
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.status) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchCustomerCurrenciesProviderDD = async (payload) => {
  const url = API_URL.CUSTOMER.GET_CURRENCIES;
  try {
    const result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }

    let res = result || [];
    res = res.map((item) => ({
      label: item.key,
      value: item.value,
    }));

    return { content: res };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchCustomerCountryProviderDD = async (payload) => {
  const url = API_URL.CUSTOMER.GET_COUNTRIES;
  try {
    let result = await getPythonApiAsyn(url, cookies.get("authorization"));

    if (result?.error) {
      throw new APIError(result);
    }
    let res = result || [];
    res = res.map((item) => ({
      label: item.value,  // value = countryname (display label)
      value: item.key,    // key   = countryid  (stored value)
    }));
    return { content: res };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchTypesByCategory = async (type) => {
  const url = `${API_URL.CUSTOMER.GET_REVENUE_TAX}?type=${type}`;
  try {
    const result = await getPythonApiAsyn(url, cookies.get("authorization"));
    if (result?.error) {
      throw new APIError(result);
    }
    const res = result || [];
    const mapped = res.map((item) => ({
      label: item.key,
      value: item.value,
    }));
    return { content: mapped };
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
